import { createFileRoute } from "@tanstack/react-router";

import { Records } from "@/features/my/records";

export const Route = createFileRoute("/(member)/(protected)/my/records")({
  component: Records,
});
